export default __webpack_public_path__ + "static/escuela-icon--white-b5633aa599c9912e3e29d3fb118b3d0f.svg";